import React from 'react';
import PropTypes from 'prop-types';
import { VstButton } from 'vstui';

class ReadOffline extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      launchingApp: false,
    };

    this._continueToBrowser = this._continueToBrowser.bind(this);
    this._launchAppOnce = this._launchAppOnce.bind(this);
    this._launchApp = this._launchApp.bind(this);
    this._downloadApp = this._downloadApp.bind(this);
    this._downloadAfterLaunch = this._downloadAfterLaunch.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
    if (Fraction.Helpers.userData()['readoffline.launchApp']) {
      if (this.props.launchOptions) {
        if (this.props.closeCallback) {
          this.props.closeCallback();
        }
        Fraction.Helpers.removeModal();
      }
      Fraction.Reporter.gaEvent("V3/read-offline", "", "autoLaunchOnStart");
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  _continueToBrowser() {
    Fraction.Helpers.saveUserData('readoffline.continueInBrowser', true);
    Fraction.Helpers.saveUserData('readoffline.launchApp', false);
    if (this.props.closeCallback) {
      this.props.closeCallback();
    }
    Fraction.Helpers.removeModal();
    Fraction.Reporter.gaEvent("V3/read-offline", "", "continueToBrowser");
  }

  _launchAppOnce() {
    Fraction.Helpers.launchInApp(this.props.isbn);
    if (this.props.closeCallback) {
      this.props.closeCallback();
    }
    Fraction.Helpers.removeModal();
    Fraction.Reporter.gaEvent("V3/read-offline", "", "launchAppOnce");
  }

  _launchApp() {
    Fraction.Helpers.launchInApp(this.props.isbn);
    Fraction.Helpers.saveUserData('readoffline.launchApp', true);
    Fraction.Helpers.addLoader(".read-offline-modal .modal-box");
    setTimeout(() => {
      Fraction.Helpers.removeLoader(".read-offline-modal .modal-box");
      if (this._isMounted) {
        this.setState({launchingApp: true});
      }
    }, 5000);
    Fraction.Reporter.gaEvent("V3/read-offline", "", "launchApp");
  }

  _downloadApp() {
    Fraction.Helpers.downloadApp();
    Fraction.Reporter.gaEvent("V3/read-offline", "", "downloadApp");
  }

  _downloadAfterLaunch() {
    Fraction.Reporter.gaEvent("V3/read-offline", "", "downloadAfterLaunch");
  }

  renderLaunchingApp() {
    return (
      <span>
        <div className="read-offline-message">
          {i18n.t("read-offline.thanks-for-using", {brand: Fraction.Brand.brand})}
        </div>
        <div className="read-offline-buttons">
          <button className="submit" onClick={this._continueToBrowser}>
            {i18n.t("read-offline.nevermind-browser")}
          </button>
          <a
            className="continue-in-browser"
            href={Fraction.Helpers.getAppURL()}
            onClick={this._downloadAfterLaunch}
          >
            {i18n.t("main-menu.download-app")}
          </a>
        </div>
      </span>
    );
  }

  mobileLaunch() {
    const url     = Fraction.Helpers.getAppURL();
    const message = i18n.t("read-offline.read-offline-download", {brand: Fraction.Brand.brand, device: Fraction.Helpers.Browser.deviceCheck(), url: url});
    return (
      <div id="mobile-launch-options">
        <div id="top-nav">
          <VstButton id="cancel" className="vst-naked" onClick={Fraction.Helpers.Modals.removeModal}>{i18n.t("base.cancel")}</VstButton>
        </div>
        <div className="read-offline-mobile-message">
          {window.toHTML(message)}
        </div>
        <img id="offline-sso-img" src="img/sso_graphic.svg" />
        <div id="instructions">
          {i18n.t("read-offline.once-have-app")}
        </div>
        <button id="launch-app" onClick={this._launchApp}>
          {i18n.t("main-menu.launch-app-sign-in")}
        </button>
      </div>    
    );
  }

  renderOptions() {
    return (
      <span>
        <div className="read-offline-message">
          {i18n.t("read-offline.auto-open", {brand: Fraction.Brand.brand})}
        </div>
        <div className="read-offline-buttons">
          <button className="submit" onClick={this._launchApp}>
            {i18n.t("read-offline.yes-always")}
          </button>
          <button className="submit" onClick={this._launchAppOnce}>
            {i18n.t("read-offline.no-just-now")}
          </button>
        </div>
      </span>
    );
  }

  render() {
    if (this.state.launchingApp) {
      return this.renderLaunchingApp();
    } else if (this.props.launchOptions) {
      return this.renderOptions();
    } else if (this.props.offlineMobile) {
      return this.mobileLaunch();
    }

    return (
      <span>
        <div className="read-offline-message">
          {i18n.t("read-offline.read-offline-message", {brand: Fraction.Brand.brand})}
        </div>
        <div className="read-offline-buttons">
          <button className="submit" onClick={this._launchApp}>
            {i18n.t("main-menu.launch-app")}
          </button>
          <button className="submit" onClick={this._downloadApp}>
            {i18n.t("main-menu.download-app")}
          </button>
          <button className="noButton continue-in-browser" onClick={this._continueToBrowser}>
            {i18n.t("read-offline.no-continue-browser")}
          </button>
        </div>
      </span>
    );
  }
}

ReadOffline.propTypes = {
  isbn: PropTypes.string.isRequired,
  launchOptions: PropTypes.bool,
  closeCallback: PropTypes.func,
};

ReadOffline.defaultProps = {
  launchOptions: false,
};

export default ReadOffline;
